import React, { lazy } from 'react';
import { QuoteIcon } from 'lucide-react';
const CustomerStories = () => {
  return <section className="py-20 bg-white" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <div className="text-center mb-16" data-id="element-139">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-140">
            Customer Success Stories
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-141">
            See how restaurants are transforming their beverage experience with
            SmartSoda
          </p>
        </div>
        <div className="grid grid-cols-1 gap-12" data-id="element-142">
          {/* Pulp Smoothie Bar */}
          <div className="bg-gray-50 rounded-2xl p-8 md:p-12 shadow-sm" data-id="element-143">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center" data-id="element-144">
              <div className="md:col-span-4" data-id="element-145">
                <div className="aspect-square bg-white rounded-xl overflow-hidden shadow-md" data-id="element-146">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/39G8u5Jwv6ZzsvRxc9k3qM/WhatsApp_Image_2025-10-05_at_22.37.28_%282%29.jpg" alt="Pulp Juice and Smoothie Bar Logo" className="w-full h-full object-contain p-4" width="400" height="400" loading="lazy" decoding="async" data-id="element-147" />
                </div>
              </div>
              <div className="md:col-span-8" data-id="element-148">
                <div className="flex flex-col h-full justify-between" data-id="element-149">
                  <div data-id="element-150">
                    <div className="flex items-center mb-4" data-id="element-151">
                      <QuoteIcon className="h-8 w-8 text-blue-500 mr-2" data-id="element-152" />
                      <h3 className="text-2xl font-bold text-navy-950" data-id="element-153">
                        Pulp Smoothie Bar
                      </h3>
                    </div>
                    <blockquote className="text-lg text-gray-700 mb-6 italic" data-id="element-154">
                      "SmartSoda has been a game-changer for our smoothie bar.
                      We've been able to expand our menu with premium craft
                      beverages while maintaining our focus on quality and
                      health. Our customers love the unique options, and we've
                      seen a 35% increase in beverage sales since
                      implementation."
                    </blockquote>
                    <div className="text-gray-900 font-medium" data-id="element-155">
                      — Sarah Johnson, Owner
                    </div>
                    <div className="text-gray-600 text-sm" data-id="element-156">
                      Cleveland, OH | Implemented 2024
                    </div>
                  </div>
                  <div className="mt-6" data-id="element-157">
                    <div className="flex flex-wrap gap-3" data-id="element-158">
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-159">
                        35% Revenue Increase
                      </span>
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-160">
                        Menu Expansion
                      </span>
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800" data-id="element-161">
                        Customer Satisfaction
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default CustomerStories;